var map = {
	"./C-DAC.png": 127,
	"./address_image.svg": 128,
	"./animated_ashutosh1.png": 129,
	"./animated_logo.svg": 130,
	"./animated_sourabh.png": 131,
	"./blogs_image.svg": 132,
	"./cloud_infrastructure.svg": 133,
	"./codeInLogo.png": 134,
	"./contactMail.png": 135,
	"./coursera_logo.png": 136,
	"./data_science.svg": 137,
	"./deeplearning_ai_logo.png": 138,
	"./delhivery_logo.png": 139,
	"./developerActivity.svg": 140,
	"./dsc_logo.png": 141,
	"./education.svg": 142,
	"./experience.svg": 143,
	"./feelingProud.svg": 144,
	"./freecopy_logo.png": 145,
	"./fullstack.svg": 146,
	"./gcp_logo.png": 147,
	"./github_logo.png": 148,
	"./googleAssistant.jpg": 149,
	"./googleAssistant.svg": 150,
	"./google_logo.png": 151,
	"./ibm_logo.png": 152,
	"./iiitk_logo.png": 153,
	"./intel_logo.jpg": 154,
	"./iu_logo.png": 155,
	"./jsFramework.svg": 156,
	"./legato_logo.png": 157,
	"./manOnTable.svg": 158,
	"./microsoft_logo.png": 159,
	"./mozilla_logo.png": 160,
	"./muffito_logo.png": 161,
	"./nextuLogo.jpg": 162,
	"./nptel_logo.png": 163,
	"./portfolio.gif": 164,
	"./programmer.svg": 165,
	"./projects_image.svg": 166,
	"./pwa.png": 167,
	"./saayaHealthLogo.png": 168,
	"./stanford_logo.png": 169,
	"./talksCardBack.svg": 170,
	"./talksCardBackAlt.svg": 171,
	"./tiktok_logo.png": 172,
	"./tit.png": 173,
	"./ui_ux_design.svg": 174,
	"./webdesire.png": 175
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33;